import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import _ from 'underscore';
import TarotReadingQuestion from './question';
import TarotReadingShuffle from './shuffle';
import TarotReadingDeckHeader from './deck-header';
import TarotReadingDeckSelect from './deck-select';
import TarotReadingDeck from './deck';
import TarotSampleInterp from './sample-interp';
import TarotSpread from '../tarot-spread';
import ReadingHeaderPrice from '../../../reading-header-price';
import { smoothScrollToElement } from '../../../../scroll';

class Component extends BaseComponent {
    constructor() {
        super();
        this.state = { accordionOpen: false };
    }

    render({ upc, deck, button_text, view }) {
        if (deck) {
            return (
                <tarot-reading-teeup>
                    <section>
                        <ReadingHeaderPrice />
                        <header>
                            <div className={'icon-teeup icon-' + upc} />
                            {this.renderReadingHeader()}
                            {this.renderHeaderP()}
                        </header>
                        {this.renderAside()}
                        <TarotReadingQuestion />
                    </section>
                    <section>
                        <TarotReadingShuffle />
                        <TarotReadingDeckHeader upc={upc} />
                        <TarotReadingDeck upc={upc} view={view} />
                        <TarotReadingDeckSelect deck={this.props.deck} />
                    </section>
                    {this.renderCaption()}
                    <TarotSpread view={view} />
                    {this.renderError()}
                    <form onSubmit={this.reveal}>
                        <div className='button-wrapper'>
                            <button
                                className={this.props.completed ? 'button-warning' : 'disabled button-warning'}
                                data-action={
                                    button_text == 'shuffle cards'
                                        ? 'Click-Shuffle-Cards-Button'
                                        : 'Click-Reveal-Meaning-Button'
                                }
                            >
                                {button_text}
                            </button>
                        </div>
                    </form>
                    {this.renderContent()}
                    {this.renderSampleInterps()}
                </tarot-reading-teeup>
            );
        }

        return null;
    }

    renderReadingHeader = () => {
        if (this.props.teeup && this.props.teeup.display_name) {
            /* eslint-disable max-len */
            if (this.props.type == 'full') {
                return (
                    <h1 className='has-margin-10-top has-margin-10-bottom-desktop has-margin-10-bottom-tablet fancy-title'>
                        {this.props.teeup.display_name}
                    </h1>
                );
            }

            return (
                <h2 className='is-h1 has-margin-10-top has-margin-10-bottom-desktop has-margin-10-bottom-tablet fancy-title'>
                    {this.props.teeup.display_name}
                </h2>
            );
            /* eslint-enable max-len */
        }

        return null;
    }

    renderHeaderP = () => {
        if (this.props.type != 'full' || this.props.sample_interps) {
            return null;
        }

        let subhead = null;

        if (this.props.teeup) {
            if (this.props.teeup.code == 'yes-or-no-tarot-redux') {
                subhead = this.props.teeup.subheader;
            } else if (this.props.teeup.display_caption) {
                subhead = this.props.teeup.display_caption;
            }

            if (subhead) {
                return (
                    <p>
                        {subhead}&nbsp;
                        {this.renderLearnMoreLink()}
                    </p>
                );
            }
        }

        return null;
    }

    renderLearnMoreLink = () => {
        if (this.props.teeup.long_description && !this.props.showContent) {
            return (
                <a
                    href='#'
                    onClick={(e) => { this.trackEvent('Tarot Readings', 'Learn More'); this.toggleAccordion(e); }}
                >
                    Learn More
                </a>
            );
        }

        return null;
    }

    renderAside = () => {
        if (this.state.accordionOpen && !this.props.showContent) {
            return (
                <aside className='details'>
                    <button onClick={this.toggleAccordion}>✕</button>
                    <h2 className='has-margin-15-bottom'>{this.props.teeup.display_name} Description</h2>
                    <summary>
                        {this.props.teeup.long_description.map((section) => (this.renderSummaryP(section)))}
                    </summary>
                    <br />
                    {this.renderCardDescriptions()}
                </aside>
            );
        }

        return null;
    }

    renderContent = () => {
        if (this.props.teeup && this.props.teeup.long_description && this.props.showContent) {
            return (
                <div className='details has-margin-60-top'>
                    <h2 className='has-margin-15-bottom'>About This {this.props.teeup.display_name}</h2>
                    <summary>
                        {this.props.teeup.long_description.map((section) => (this.renderSummaryP(section)))}
                    </summary>
                    <br />
                    {this.renderCardDescriptions()}
                    <row className='is-justified-center has-margin-30-top'>
                        <column>
                            <a href='' className='button button-warning-simple' onClick={(e) => this.goTo(e, 'main')}>
                                START MY READING
                            </a>
                        </column>
                    </row>
                </div>
            );
        }

        return null;
    }

    renderCardDescriptions = () => {
        if (
            ! _.contains([
                'yes-or-no-tarot-redux',
                'two-hearts-tarot-redux',
            ], this.props.upc)
            &&
            this.props.teeup.positions[0].title
        ) {
            return [
                <h2>
                    {this.props.showContent ? 'Tarot Card Positions' : 'Card Descriptions'}
                </h2>,
                <dl>
                    {this.props.teeup.positions.map((position) => (this.renderPosition(position)))}
                </dl>,
            ];
        }

        return null;
    }

    renderSummaryP = (section) => {
        if (section) {
            return (<p dangerouslySetInnerHTML={{__html: section}} />);
        }

        return null;
    }

    renderPosition = (position) => {
        if (position.title && position.short_description) {
            return (
                <virtual no-reorder>
                    <dt>{position.title}: </dt>
                    <dd>{position.short_description}</dd>
                    <br />
                </virtual>
            );
        }

        return null;
    }

    renderCaption = () => {
        if (this.props.type !== 'full' && this.props.teeup && this.props.teeup.display_caption) {
            return (
                <aside className='details-caption'>
                    <p>{this.props.teeup.display_caption}</p>
                </aside>
            );
        }

        return null;
    }

    renderError = () => {
        if (this.props.error) {
            return (
                <div className='error'>
                    <p className={this.props.error.remaining ? 'show' : ''}>
                        Please choose {this.props.error.remaining} more&nbsp;
                        {parseInt(this.props.error.remaining, 10) > 1 ? 'cards' : 'card'} from the deck above first.
                    </p>
                </div>
            );
        }

        return null;
    }

    renderSampleInterps = () => {
        if (this.props.sample_interps) {
            return (
                <section>
                    {this.props.positions.map((position, i) => (this.renderSampleInterp(i)))}
                </section>
            );
        }

        return null;
    }

    renderSampleInterp = (i) => {
        if (i) {
            return (<TarotSampleInterp i={i} />);
        }

        return null;
    }

    reveal = (e) => {
        e.preventDefault();
        this.trackEvent('Tarot Readings', 'Reveal Meaning');

        if (this.props.upc == 'yes-or-no-tarot-redux' && this.props.completed) {
            if (this.props.view == 'view-1') { //moving from view 1 to view 2
                //set spread to picked_cards (shuffled)
                let cards = this.props.picked_cards;

                if (cards[0] != 10) {
                    cards[0] = 10;
                }

                cards = _.shuffle(cards);

                this.props.updateSpread(cards);

                //set tarot-reading.button_text to 'reveal the meaning'
                this.props.buttonText('reveal the meaning');

                //empty tarot-reading.cards
                this.props.cards([]);

                //hide 'choose a deck' select input
                document.querySelector('tarot-reading select').style.display = 'none';

                //set question subject, in new p.subject-set
                const questionP = document.querySelector('tarot-question p.subject'); //old p.subject
                if (questionP) {
                    questionP.style.display = 'none';
                }

                const questionInput = document.querySelector('tarot-question input'); //old question input
                if (questionInput) {
                    questionInput.style.display = 'none';
                }

                //new question p
                const subjectP = document.createElement('p');
                subjectP.classList.add('subject-set');
                subjectP.innerHTML = 'Your Question: ' + this.props.subject;

                //add new question p to tarot-question element
                document.querySelector('tarot-question').appendChild(subjectP);

                //remove subheadline and 'Learn More' link
                document.querySelector('tarot-reading header > p').style.display = 'none';

                return false;
            }
        }

        this.props.fetch();
        return false;
    }

    toggleAccordion = (e) => {
        e.preventDefault();
        this.setState({ accordionOpen: !this.state.accordionOpen });
    }

    goTo = (e, chapter) => {
        e.preventDefault();
        smoothScrollToElement(document.querySelector(chapter));
    }

    trackEvent = (category, label) => {
        const action = this.props.logged_in ? 'LI Click' : 'LO Click';

        this.props.trackEvent([category, action, label]);
    }
}

const mapStateToProps = (state) => ({
    button_text: state.product.submitting ? 'submitting…' : state['tarot-reading'].button_text,
    completed: state['tarot-reading'].cards.length === state['tarot-reading'].positions.length,
    deck: state.deck,
    error: state['tarot-reading'].error,
    picked_cards: state['tarot-reading'].cards,
    positions: state['tarot-reading'].positions,
    sample_interps: state['tarot-reading'].sample_interps,
    teeup: state.product.teeup,
    upsell_upc: state.product.teeup && state.product.teeup.upsell_upc,
    subject: state['tarot-reading'].subject || 'Unspoken',
    showContent: state.product && state.product.description && state.product.description.code
        && _.contains(['celtic-cross-sample', 'celtic-cross-love-sample'], state.product.description.code),

});

const mapDispatchToProps = (dispatch) => ({
    fetch: () => dispatch({ type: 'tarot-reading:fetch' }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    updateSpread: (payload) => dispatch({
        type: 'spread:update',
        payload: payload,
    }),
    buttonText: (payload) => dispatch({
        type: 'tarot-reading:update',
        payload: {
            button_text: payload,
        },
    }),
    cards: (payload) => dispatch({
        type: 'tarot-reading:update',
        payload: {
            cards: payload,
        },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
